import { makeStyles } from '@mui/styles'
import React from 'react'
import { Grid } from '@mui/material'

import {
  BaseDialog,
  StyledTypography,
  twinStatusesCodes,
  twinStatusesMap,
} from 'shared'

import { withModal } from 'utils/providers/ModalProvider'

import { BaseModalComponentType } from '../types'

import modals from 'constants/modals'

import CampaignTwinStatus from 'components/CampaignTwinStatus'

const useStyles = makeStyles((theme) => {
  return {
    dialog: {
      '& .MuiPaper-root': {
        width: '700px',
      },
    },
    row: {
      borderBottom: `1px solid ${theme.palette.divider}`,
      padding: '12px 0',
      flexWrap: 'nowrap',

      '&:last-child': {
        border: 'none',
        paddingBottom: 0,
      },
    },
    status: {
      minWidth: '100px',
      textAlign: 'center',
    },
  }
})

export const statusInfo = [
  {
    status: {
      code: twinStatusesCodes.unassigned,
      text: twinStatusesMap.unassigned,
    },
    description: 'You submitted your application to the campaign.',
  },
  {
    status: {
      code: twinStatusesCodes.enrolled,
      text: twinStatusesMap.enrolled,
    },
    description: 'Your application to the campaign was approved.',
  },
  {
    status: {
      code: twinStatusesCodes.submitted,
      text: twinStatusesMap.submitted,
    },
    description: 'You submitted your content for the campaign.',
  },
  {
    status: {
      code: twinStatusesCodes.overdue,
      text: twinStatusesMap.overdue,
    },
    description: 'The content submission deadline for the campaign has passed.',
  },
  {
    status: {
      code: twinStatusesCodes.exempted,
      text: twinStatusesMap.exempted,
    },
    description:
      'You are exempt from the campaign and are not required to submit content.',
  },
]

const StatusInfoModal = ({ closeModal, isOpen }: BaseModalComponentType) => {
  const classes = useStyles()

  return (
    <BaseDialog
      open={isOpen}
      onClose={closeModal}
      title="Statuses information"
      className={classes.dialog}
    >
      <Grid>
        {statusInfo.map((el) => (
          <Grid
            key={el.status.code}
            container
            alignItems="center"
            className={classes.row}
          >
            <CampaignTwinStatus status={el.status} className={classes.status} />
            <StyledTypography sx={{ ml: 2, lineHeight: '1' }}>
              {el.description}
            </StyledTypography>
          </Grid>
        ))}
      </Grid>
    </BaseDialog>
  )
}

export default withModal(modals.statusInfoModal)(StatusInfoModal)
